import {
  useGetPlaybookQuery,
  useUpdatePlaybookMutation,
} from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { usePermissionsContext } from '../../utils';
import { InfoPageEditableTitle } from '../InfoPageEditableTitle';
import { usePlaybookPageProps } from './PlaybookPageContext';

export const PlaybookPageTitle = () => {
  const { workspaceId, playbookId, organizationId, readOnly } =
    usePlaybookPageProps();
  const { data: playbook } = useGetPlaybookQuery({
    id: playbookId,
    workspaceId,
    organizationId,
  });
  const [updatePlaybook] = useUpdatePlaybookMutation();
  const { getPermissions } = usePermissionsContext();

  const updatePlaybookPermission = getPermissions(
    PermissionKey.playbook,
    PermissionAction.updatePlaybookById
  );

  return (
    <InfoPageEditableTitle
      title={playbook?.name}
      onTitleChange={(newName) =>
        updatePlaybook({
          id: playbookId,
          workspaceId,
          organizationId,
          name: newName,
          withOptimisticUpdate: true,
        })
      }
      disabled={readOnly || !updatePlaybookPermission}
    />
  );
};
